<template>
    <div aria-hidden="true" aria-labelledby="modalFillInLabel" role="dialog" tabindex="-1" class="modal modal-default modal-delete" id="modal-delete-coach">
      <div class="modal-dialog">
        <div class="modal-content">
          <header class="modal-header">
            <template>
              <strong>{{ __('Archive dietitian') }}</strong>
              <p>{{ __('Do you really want to archive this dietitian?') }}</p>
            </template>
          </header>

          <div class="modal-body">
            <div class="btn-group">
                <VButton :label="__('Cancel')" modal-target="dismiss" variant="secondary" />
                
                <form :action="`/coaches/${coach.id}/archive`" method="POST">
                  <input type="hidden" name="_token" :value="csrf">
                  <VButton :label="__('Yes, archive')" type="submit" color="danger" />
                </form>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  props: {
    coach: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    } 
  }
}
</script>
